import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="auth-callback">
        <div className="auth-callback-card">
          <div className="spinner" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Came here from a share invite before signing in: go back and finish accepting it.
  let pendingInvite: string | null = null;
  try { pendingInvite = localStorage.getItem('pendingShareInvite'); } catch { /* storage unavailable */ }
  if (pendingInvite) {
    return <Navigate to={`/share-invite/${encodeURIComponent(pendingInvite)}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
